module.exports = __webpack_public_path__ + "img/BAWS_Sword1_1_3.7cfcb8cd.png";